var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.975 16.25H12.025V14.75H3.975V16.25ZM3.975 12H12.025V10.5H3.975V12ZM1.5 20.5C1.1 20.5 0.75 20.35 0.45 20.05C0.15 19.75 0 19.4 0 19V2C0 1.6 0.15 1.25 0.45 0.95C0.75 0.65 1.1 0.5 1.5 0.5H10.525L16 5.975V19C16 19.4 15.85 19.75 15.55 20.05C15.25 20.35 14.9 20.5 14.5 20.5H1.5ZM9.775 6.65V2H1.5V19H14.5V6.65H9.775ZM1.5 2V6.65V2V19V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/Tickets.5357bf81d9187a6a5ec56930ee5101c6.svg";
export { ForwardRef as ReactComponent };